import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import UnwrapLinkEditing from './unwraplinkediting';

export default class UnwrapLink extends Plugin {
  static get pluginName() {
    return 'UnwrapLink';
  }

  static get requires() {
    return [ UnwrapLinkEditing ];
  }
}